import React, { useEffect, useState } from 'react'; 
import styled from 'styled-components';
import axios from 'axios';

const MerchantReview = () => {
  const [remarks, setRemarks] = useState('');
  const [merchantDetails,setMerchantDetails] = useState([])

  useEffect(() => {
  const googleLogin = localStorage.getItem('googleLogin');
  // console.log(googleLogin)

  if (googleLogin == 'false') {
    const data = localStorage.getItem('merchantLogin');
    if (data) setMerchantDetails(JSON.parse(data));
    // console.log("merchantLogin",data);
  } else {
    const data = localStorage.getItem('merchantDashboardLogin');
    if (data) setMerchantDetails(JSON.parse(data));
    // console.log('merchantDashboardLogin',data);
  }
}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      userId: 3, 
      couponId: 2, 
      merchantId: merchantDetails?.merchantId, 
      saleAmount: 1000, 
      saleDate: new Date().toISOString(),
      remarks: remarks
    };

    try {
      await axios.post("https://api.bakpoket.com/api/AToZ/submitMerchantSale", data);
      alert("Review submitted successfully!");
      setRemarks('');
    } catch (error) {
      console.error("Error submitting Review:", error);
      alert("Something went wrong!");
    }
  };

  return (
    <Wrapper>
    <Card>
      <h2 className='text-center'>Submit Merchant Review</h2>
      <form onSubmit={handleSubmit}>
        <textarea
          placeholder="Write your Review"
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
          required
        />
        <button type="submit">Submit</button>
      </form>
    </Card>
    </Wrapper>
  );
};

export default MerchantReview;

const Wrapper = styled.section`
  height: 60vh;
  display: flex;
  justify-content: center; /* horizontal center */
  align-items: center;     /* vertical center */
  // padding: 10px;
`;


const Card = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
  margin: auto;

  h2 {
    font-size: 22px;
    margin-bottom: 20px;
    color: #2a4157;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;

    input[type="file"] {
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 6px;
    }

    button {
      padding: 10px 15px;
      background-color: #ef4766;
      border: none;
      color: white;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;
      transition: background 0.3s;

      &:hover {
        background-color: #d63c5b;
      }
    }
  }

  @media (max-width: 768px) {
    max-width: 260px;
    width: 85%;
    padding: 10px;

    h2 {
      font-size: 13px;
    }

    button {
      font-size: 10px;
      padding: 8px 12px;
    }

    input[type="file"] {
      padding: 6px;
      border: 1px solid #ccc;
      border-radius: 6px;
      font-size:11px;
    }
  }
`;
